/**
 * @fileoverview A hook that checks if all required assets are loaded.
 * It uses the `useFonts` hook to check if the fonts are loaded.
 *
 * @example
 * const { result } = renderHook(() => useAssets())
 * expect(result.current).toBe(true) // When assets are loaded
 */

import { useFonts } from './useFonts'

/**
 * @function useAssets
 * @description Hook to check if all required assets are loaded.
 * @returns {boolean} - Whether all assets are loaded.
 */
export function useAssets(): boolean {
    const areFontsLoaded = useFonts()

    return areFontsLoaded
}
